import { EditorContentProps } from '@tiptap/react';
import { ReactNode } from 'react';

import { Box, forwardRef, rem, StyleProps, useFormControl } from '@bonusly/design-system';

import { RichTextControls } from './rich-text-controls';
import { StyledEditor } from './styled-editor';

interface RichTextInputProps extends Omit<EditorContentProps, 'color' | 'height' | 'width'>, StyleProps {
	children?: ReactNode;
}

export const RichTextInput = forwardRef<RichTextInputProps, 'div'>(({ children, editor = null, ...rest }, ref) => {
	const formProps = useFormControl({ readOnly: true, ...rest });

	return (
		<Box
			border="1px solid"
			borderColor="inherit"
			borderRadius="md"
			p={1}
			{...formProps}
			{...rest}
			_invalid={{
				borderColor: 'error.inputBorder',
				boxShadow: '0 0 0 1px #d82c2fff',
			}}
		>
			<RichTextControls editor={editor} />
			<StyledEditor editor={editor} ref={ref} minH={rem(100)} outline="none" p={2} {...rest} />

			{children}
		</Box>
	);
});
